import type { ScrollView, View } from "@-/com.npmjs.react-native";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext, type RefObject } from "react";

export type MorphemeInfoPanelAccordionScrollView = ScrollView & {
  getInnerViewRef?: () => View | null;
  scrollTo?: (opts: { animated: boolean; y: number }) => void;
};

export type MorphemeInfoPanelAccordionScrollControlContextValue = {
  scrollHeaderIntoView: (headerRef: RefObject<View | null>) => void;
  scrollRef: RefObject<MorphemeInfoPanelAccordionScrollView | null>;
  scrollYRef: RefObject<number>;
};

export const MorphemeInfoPanelAccordionScrollControlContext = createContext(
  defaultError<MorphemeInfoPanelAccordionScrollControlContextValue>(
    "MorphemeInfoPanelAccordionScrollControlContext",
  ),
);
